import * as zod from 'zod';

export const StitchingConfig = zod.object({
  enabled: zod.boolean().default(false),
  stitch: zod.number().gt(0), // Stitch size in meters
  space: zod.number().gt(0), // Space between stitches in meters
  craterFillAfterEveryStitch: zod.boolean().default(true), // Alternative: only last stitch
});

export type StitchingConfig = zod.infer<typeof StitchingConfig>;
